module.exports = __webpack_public_path__ + "d9389445addedb7eccc55bf04327421d.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/807.png
// module id = 1711
// module chunks = 2